function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedfinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 61.101742 77.46875",
    id: "svg1608",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.06475928,0.7296741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "m 55.256706,68.358756 c -1.018117,-0.40878 -2.043907,-1.19221 -4.792134,-5.81792 l -5.477404,-9.08473 -6.457685,-10.70081 -0.545042,-0.91229 c 0.314325,-0.087 0.624682,-0.18917 0.931334,-0.29157 7.411508,-2.5437 11.73427,-9.32682 11.73427,-19.00581 0.0095,-2.36352 -0.487891,-4.70159 -1.458912,-6.85647 -0.971021,-2.15487 -2.392892,-4.0764 -4.169833,-5.63493 C 44.482608,9.5917859 43.917723,9.1608059 43.329289,8.7634559 38.4046,5.4929659 31.761441,4.2703259 22.915336,4.2703259 H 6.1882138 5.9346 c -1.0901595,0 -1.1923619,0.617 -0.7646259,1.181 0.3785274,0.50723 0.8214055,1.18101 1.0106673,2.88816 V 61.746026 c -0.1892618,2.17276 -0.6321399,2.86544 -1.0106673,3.36894 -0.4315214,0.56383 -0.2422576,1.21126 0.8441174,1.19989 H 18.403291 v -22.65495 h 5.628719 l 3.9556,6.71883 4.958636,8.45264 2.433902,4.11083 c 3.06996,5.17049 5.761302,8.03593 11.109854,8.64553 0.779727,0.0992 1.564745,0.14975 2.350823,0.15134 h 0.82497 c 1.926696,0 3.785394,-0.75697 4.973902,-1.26815 0.159015,-0.0606 0.314325,-0.12118 0.469371,-0.18918 1.404409,-0.62071 1.014413,-1.5785 0.147638,-1.92299 z M 26.272872,34.995326 h -7.869581 v -21.8523 h 7.869581 c 3.895063,0 6.866519,0.50342 9.084786,2.52476 0.832379,0.80121 1.478492,1.77556 1.892565,2.85411 0.595577,1.6088 0.881856,3.31557 0.84402,5.03063 0,2.9033 -0.268816,11.4428 -11.821371,11.4428 z",
    fill: "#a02021",
    style: {
      display: "inline",
      strokeWidth: 0.264583
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedfinIcon);
export default __webpack_public_path__ + "static/media/redfin-icon.6632cb41b4532d87891a34cfe82b8654.svg";
export { ForwardRef as ReactComponent };